<template>
  <div
    class="warpper"
  >
    <!-- 骨架屏 -->
    <Skeleton v-if="loading" />

    <template v-else>
      <!-- 购物车列表 -->
      <div
        v-if="cartList.length"
        class="cart-list"
      >
        <SpuItem
          v-for="item in cartList"
          :key="item.offerId"
          :item="item"
        />
      </div>

      <!-- 状态下空样式 -->
      <Empty
        v-else
      />
    </template>
  </div>
</template>

<script setup>
import Skeleton from './Skeleton.vue'
import SpuItem from './SpuItem.vue'
import Empty from './Empty.vue'
import { useCart } from '@/views/Carts/hooks/useCart'

const { loading, cartList } = useCart()
</script>

<style lang='less' scoped>
.warpper {
  flex: 1;
  padding: 24px 0;
}
</style>
